import { useTheme } from "@amx/ux-twoui-theming";
import { PrimaryButton } from "@fluentui/react";
import React from "react";
import { getButtonStyles } from "./LeftNavBypassBlocksButton.styles";
import { BypassBlocksButtonProps } from "./LeftNavBypassBlocksButton.types";

// This is the button used to skip directly to the main content in the page.
// More info in the following documentation: https://www.w3.org/WAI/WCAG21/Understanding/bypass-blocks.html
export const LeftNavBypassBlocksButton: React.FC<BypassBlocksButtonProps> = ({
    text,
    "aria-label": ariaLabel,
    "data-bi-id": dataBiId,
    targetId
}) => {
    const theme = useTheme();

    const bypassBlocksButtonClick = () => {
        const mainContent = document.getElementById(targetId);
        mainContent?.focus();
        mainContent?.scrollIntoView();
    };

    return (
        <PrimaryButton styles={getButtonStyles(theme)} ariaLabel={ariaLabel} data-bi-id={dataBiId} onClick={bypassBlocksButtonClick}>
            {text}
        </PrimaryButton>
    );
};
